import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from '@material-ui/core/styles';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import { ApolloProvider } from '@apollo/client';
import { theme } from '../../theme/theme';
import ChannelBreakdownWrapper from '../../common/wrapperComponents/ChannelBreakdownWrapper';
import TableFilters from '../Filter/TableFilters';
import ErrorDialog from '../ErrorDialog/ErrorDialog';
import debounce from 'lodash/debounce';
import analytics from '../../helper/analytics';
import tracker from '../../constants/tracker';
import apolloClient from '../../apollo';
import { getCurrentEnvBaseUrl, getErrorMessage } from '../../helper/utils';
import Table from '../Table';
import { useSelector } from 'react-redux';
import ComparisonChartWrapper from '../../common/wrapperComponents/ComparisonChartWrapper/ComparisonChartWrapper';
import AddToWatchListWithButton from '../CustomAlert';

const Item = styled(Grid)(({ theme }) => ({
	...theme.typography.body2,
	padding: theme.spacing(1.5),
	textAlign: 'center',
	color: theme.palette.text.secondary,
	'@media (min-width: 360px) and (max-width: 850px)': {
		paddingRight: theme.spacing(2),
		paddingLeft: theme.spacing(2),
	},
}));

function Sales(props) {
	const { errorDialog, errorCode } = useSelector(
		(state) => state.fullCompanyViewReducer
	);
	const { weekFilter, category, startDate, endDate } = props;

	const selectedFilters = useSelector(
		(state) => state.salesReducer.selectedFilters
	);

	const { selectedFilter } = selectedFilters;

	const [width, setWidth] = useState(0);

	const selectedView = useSelector(
		(state) => state.appGuideReducer.selectedView
	);

	useEffect(() => {
		const updateSize = debounce(() => {
			setWidth(window.innerHeight);
		}, 1500);
		window.addEventListener('resize', updateSize);
		updateSize && updateSize();
		analytics.trackPageInfo(tracker.PAGE_ID.SALESDASHBOARD);
		return () => window.removeEventListener('resize', updateSize);
	}, [selectedView]);

	return (
		<ThemeProvider theme={theme}>
			{errorDialog && (
				<ErrorDialog
					title="Something isn’t working"
					description={getErrorMessage(errorCode)}
					secondaryDescription={`Error Code: E${errorCode}`}
					option="Reload"
					secondaryOption="Go to Scintilla home"
					optionClickHandler={() => {
						window.location.reload();
					}}
					secondaryOptionClickHandler={() => {
						const env = getCurrentEnvBaseUrl();
						window.location.href = `https://${env}/apps`;
					}}
					alertCloseHandler={() => {}}
				/>
			)}

			<AddToWatchListWithButton />

			<Box sx={{ flexGrow: 1 }} style={{ textAlign: 'center' }}>
				<Grid container>
					<Grid item xs={12} sm={12} md={6} lg={6}>
						<Item>
							<ComparisonChartWrapper />
						</Item>
					</Grid>
					<Grid item xs={12} sm={12} md={6} lg={6}>
						<Item>
							<ChannelBreakdownWrapper
								selectedFilter={selectedFilter}
								updatedWidth={width}
								weekFilter={weekFilter}
								startDate={startDate}
								endDate={endDate}
								tab={'Sales'}
								category={category}
							/>
						</Item>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<Box
							sx={{
								border: '1px solid #dadce0',
								borderRadius: '8px',
								margin: '12px',
							}}>
							<ApolloProvider client={apolloClient}>
								<TableFilters />
								<Table selectedFilter={selectedFilter} />
							</ApolloProvider>
						</Box>
					</Grid>
				</Grid>
			</Box>
		</ThemeProvider>
	);
}

Sales.propTypes = {
	weekFilter: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	selectedFilter: PropTypes.string,
	category: PropTypes.string,
	startDate: PropTypes.string,
	endDate: PropTypes.string,
	param: PropTypes.object,
};

export default Sales;
